import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgMehrEghtesad = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g
      fillRule='evenodd'
      clipPath='url(#mehr_eghtesad_svg__a)'
      clipRule='evenodd'
    >
      <path
        fill='#00A450'
        d='M11.989 24 9.34 21.35l6.641-6.676c1.952-1.963 5.28-1.153 6.54 1.714-1.322-.118-2.6-.325-3.703.8z'
      />
      <path
        fill='#00A450'
        d='m0 12.006 2.647-2.652 6.667 6.65c1.961 1.955 1.152 5.286-1.71 6.547.119-1.321.323-2.602-.799-3.707z'
      />
      <path
        fill='#00A450'
        d='m12.027 0 2.649 2.644L8.035 9.32c-1.952 1.963-5.278 1.153-6.54-1.714 1.322.118 2.61.325 3.703-.79z'
      />
      <path
        fill='#00A450'
        d='m24 11.988-2.649 2.652-6.667-6.65c-1.961-1.953-1.15-5.284 1.711-6.547-.118 1.323-.324 2.612.8 3.707z'
      />
      <path
        fill='#F7941E'
        d='M8.084 11.986a3.86 3.86 0 0 1 2.379-3.564 3.85 3.85 0 0 1 4.198.837 3.858 3.858 0 0 1-2.724 6.584 3.85 3.85 0 0 1-2.724-1.13 3.86 3.86 0 0 1-1.129-2.727'
      />
    </g>
    <defs>
      <clipPath id='mehr_eghtesad_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgMehrEghtesad)
export default ForwardRef
